import {Project, ProjectCustomStatuses} from "./project";
import {Comment} from "./comment";
import {FormFile} from "./material";
import {HistoryItem} from "./historyItem";
import {Room} from "./room";
import {Unit} from "./unit";
import {Floor} from "./floor";
import {Company} from "./company";
import {Task} from "./task";
import {DateType} from "./date-type";
import {Trade} from "./trade";

export class Area {
  id: number;
  name: string;
  publicId: string;
  orderNumber: number;
  version: number;
  templateVersion: number;
  status: ProjectCustomStatuses;
  areaWeight: AreaWeight = AreaWeight.MEDIUM;
  statusProgress: number;
  comments: Comment[] = [];
  files: FormFile[] = [];
  history: HistoryItem[] = [];

  attachmentsAmount: number;
  commentsAmount: number;
  notFinishedLinkedTasksAmount: number;

  errorName: boolean;
  changed: boolean;

  pp_opacity: any;

  company: Company;
  project: Project;
  floor: Floor;
  unit: Unit;
  room: Room;
  linkedTasks: Task[] = [];
  type: string
  paddingLeft: number;
  startDate: null;
  endDate: null;
  effStartDate: null;
  effEndDate: null;
  actualStartDate: string | null;
  actualEndDate: string | null;
  dateType: DateType;
  trade: Trade | null;
  trades?: Trade[];
}

export class AreaListItem {
  id: number;
  name: string;
  publicId: string;
  areaWeight: AreaWeight;
  status: ProjectCustomStatuses;
  statusProgress: number;
  roomShort: Room;
  unitShort: Unit;
  floorShort: Floor;
  attachmentsAmount: number;
  commentsAmount: number;
}


export class AreasAmount {
  todo: number = 0;
  inProgress: number = 0;
  done: number = 0;
}

export enum AreaStatus {
  TO_DO = "To Do",
  IN_PROGRESS = "In Progress",
  DONE = "Done"
}

export enum AreaStatusDefaultOrder {
  TO_DO = -3,
  IN_PROGRESS = -2,
  DONE = -1
}


export enum AreaWeight {
  NO_WEIGHT = "NO_WEIGHT",
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  HUGE = "HUGE",
}
